import { useEffect } from 'react';
import { useGame } from '../utils/GameContext';
import { soundManager } from '../utils/SoundManager';
// Note: useAudio is implicitly handled by SoundManager via Context updates

const BackgroundMusic = () => {
    const { gameState } = useGame();

    useEffect(() => {
        if (gameState === 'playing' || gameState === 'countdown') {
            // Fade in music when game starts
            soundManager.playMusic(1.5);
        } else if (gameState === 'paused' || gameState === 'gameover') {
            // Fade out when paused/ended
            soundManager.stopMusic(0.5);
        }
    }, [gameState]);

    return null;
};

export default BackgroundMusic;